// removed by extract-text-webpack-plugin
module.exports = {"fh5coperson":"src-components-Section----UserLight-module---fh5coperson---3EcAB","fh5coname":"src-components-Section----UserLight-module---fh5coname---2XqD1","fh5codesignation":"src-components-Section----UserLight-module---fh5codesignation---I4aWy","fh5cobio":"src-components-Section----UserLight-module---fh5cobio---3WnIU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/UserLight.module.scss
// module id = 434
// module chunks = 110243015079028